import { render } from "./Frontend-errors-page.vue?vue&type=template&id=0ca6349a"
import script from "./Frontend-errors-page.vue?vue&type=script&lang=js"
export * from "./Frontend-errors-page.vue?vue&type=script&lang=js"

import "./Frontend-errors-page.vue?vue&type=style&index=0&id=0ca6349a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__